module.exports = __webpack_public_path__ + "static/apple-icon-152x152.fb1ecd6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/apple-icon-152x152.png
// module id = 599
// module chunks = 114276838955818